import * as tConst from "../../../common/Constants";

export function CreateData(newItem) {
    var data = [
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_TITLE,
            "from": null,
            "value": newItem.newTitle
        }
    ]

    if (newItem.path) {
        const _path=        {
            "op": "add",
            "path": "/fields/" + tConst.AF_AREA_PATH,
            "value": newItem.path
        }
        data.push(_path);

    }
    if (newItem.startIteration)
    {    
        const _startIteration = {
            "op": "add",
            "path": "/fields/" + tConst.AF_START_ITERATION,
            "value": newItem.startIteration
        }
        data.push(_startIteration);
    }
    if (newItem.endIteration)
    {

        const _endIteration = {
            "op": "add",
            "path": "/fields/" + tConst.AF_END_ITERATION,
            "value": newItem.endIteration
        }
        data.push(_endIteration);
    }
    if (newItem.PlanningPri) {

        const _planningPri = {
            "op": "add",
            "path": "/fields/" + tConst.AF_PLANNING_PRIORITY,
            "value": newItem.PlanningPri
        }
        data.push(_planningPri);
    }


    // if (newItem.parentId !== null && newItem.parentId !== 0) {
    //     data.push({
    //         "op": "add",
    //         "path": "/relations/-",
    //         "value": {
    //             "rel": "System.LinkTypes.Hierarchy-Reverse",
    //             "url": tConst.AZURE_DEVOPS_API_URI + `/wit/workItems/${newItem.parentId}`
    //         }
    //     });

    // }

    return data;
}
